export const IMAGES = {
  heroMentoring: "/photos/huddle-trust.jpg",
  professional: "/photos/founder-table.jpg",
  volunteer: "/photos/group-hug.jpg",
  outdoors: "/photos/outdoor-huddle.jpg",
  graduation: "/photos/prayer-huddle.jpg",
  graduate2: "/photos/founder-table.jpg",
  huddleTrust: "/photos/huddle-trust.jpg",
  founderTable: "/photos/founder-table.jpg",
  prayerHuddle: "/photos/prayer-huddle.jpg",
  groupHug: "/photos/group-hug.jpg",
  outdoorHuddle: "/photos/outdoor-huddle.jpg",
  grandOpening: "/photos/grand-opening.jpg",
  changeTshirts: "/photos/change-tshirts.jpg",
  classroomCohort: "/photos/classroom-cohort.jpg",
  outdoorGroup: "/photos/outdoor-group.jpg",
  schoolLineup: "/photos/school-lineup.jpg",
};

export const STATS = [
  { label: "Students Mentored", value: "420+" },
  { label: "Volunteer Mentors", value: "68" },
  { label: "School Partnerships", value: "12" },
  { label: "Community Service Hours", value: "9,400" },
  { label: "Families Served", value: "310+" },
];

export const TESTIMONIALS = [
  {
    name: "Angela T.",
    role: "Parent, Forest Park",
    quote:
      "The Change Center gave my son a brotherhood he didn't know he needed. His grades, his attitude — everything changed.",
  },
  {
    name: "Coach Reggie",
    role: "Volunteer Mentor",
    quote:
      "This isn't a program — it's a family. Every Saturday I show up and leave more inspired than when I arrived.",
  },
  {
    name: "Principal Davis",
    role: "Forest Park Middle School",
    quote:
      "Our partnership with The Change Center has measurably improved attendance, behavior, and academic outcomes.",
  },
];

export const PARTNERS = [
  { name: "Forest Park Middle School", type: "School" },
  { name: "Tapestry Charter School", type: "School" },
  { name: "Clayton County Juvenile Court", type: "Government" },
  { name: "City of Forest Park", type: "Government" },
  { name: "The Change Church of Atlanta", type: "Faith Partner" },
];

export const NEWS = [
  {
    slug: "2026-spring-cohort",
    title: "Announcing our 2026 Spring Cohort",
    date: "2026-01-15",
    excerpt:
      "45 new young men joined the brotherhood this January. Meet them, and the mentors who will walk with them.",
    category: "Program",
  },
  {
    slug: "tapestry-expansion",
    title: "Expanding to Tapestry Charter School",
    date: "2025-12-02",
    excerpt:
      "Our second school partnership is officially live. Weekly programming begins in January.",
    category: "Partnership",
  },
  {
    slug: "court-referral-program",
    title: "New Court Referral Partnership",
    date: "2025-11-10",
    excerpt:
      "Clayton County Juvenile Court has selected us as a diversion partner for first-time offenders.",
    category: "Community",
  },
];

export const RESOURCES = [
  { title: "Parent Guide", desc: "Everything parents need to know about the program.", tag: "Guides" },
  { title: "Mentor Handbook", desc: "Roles, boundaries, and best practices for our mentors.", tag: "Guides" },
  { title: "Student Handbook", desc: "Expectations and opportunities for our mentees.", tag: "Guides" },
  { title: "Homework Resources", desc: "Curated tutoring links, free math/reading tools.", tag: "Academic" },
  { title: "Scholarships", desc: "Local and national scholarships open to our mentees.", tag: "College" },
  { title: "Career Resources", desc: "Resume templates, LinkedIn tips, and interview prep.", tag: "Career" },
  { title: "Mental Health Resources", desc: "Crisis lines, teen counseling, and family support.", tag: "Wellness" },
  { title: "Emergency Resources", desc: "Food, shelter, and safety hotlines in Clayton County.", tag: "Emergency" },
];

export const CORE_VALUES = [
  { name: "Brotherhood", desc: "We show up for each other — no exceptions." },
  { name: "Excellence", desc: "We pursue mastery in school, work, and character." },
  { name: "Faith", desc: "We are grounded in hope and purpose." },
  { name: "Service", desc: "We lead by lifting others." },
  { name: "Discipline", desc: "We keep our word and finish what we start." },
  { name: "Legacy", desc: "We build futures worth passing on." },
];

export const LEADERSHIP = [
  { name: "Pastor Duane Thomas Jr.", role: "Founder & Executive Director", photo: "/photos/duane-thomas.jpg" },
  {
    name: "Warren Washington",
    role: "Co-Director",
    photo: null,
    bio: "Warren Washington serves as Co-Director of Change Center Mentoring Group, working alongside Pastor Duane Thomas Jr. to lead the organization's programs, mentors, and community partnerships. He helps carry out the mission of guiding young men toward stronger, more purposeful futures.",
  },
  { name: "Dr. Kenya Watkins", role: "Director of Programs" },
  { name: "Coach Reggie Simmons", role: "Head of Mentor Development" },
  { name: "Ms. Angela Thomas", role: "Family Advocate & Case Manager" },
  { name: "Andre Foster", role: "Director of Workforce & Career" },
  { name: "Nia Roberts, LCSW", role: "Mental Health & Wellness Lead" },
];

export const VOLUNTEER_CATEGORIES = [
  "Tutoring", "Events", "Transportation", "Cooking", "Photography",
  "Administration", "Fundraising", "Technology", "Marketing", "Church Partnerships",
];

export const MENTOR_INTERESTS = [
  "Academic Tutoring", "Sports & Fitness", "Faith & Character", "Career & Workforce",
  "Financial Literacy", "STEM", "Arts & Design", "Public Speaking", "Mental Health",
];
